import { loggerCreate } from '@blaze-shared/logger-util';

export const layoutMigrationLog = loggerCreate('layout_migration', null, null, null);
